import { initSetLogo } from './helpers.js';

// eslint-disable-next-line import/prefer-default-export
export const setLogo = (src) => initSetLogo('.menu__logo-icon', 'menu__logo-icon_hidden', src);
